// @flow
import Api from './ApiWorker';

export const authAdmin: ApiRequest<any> = () => Api.send('/auth/admin', 'GET', {}, true);
export const authUser: ApiRequest<any> = () => Api.send('/auth/user', 'GET');

export const getItems: ApiRequest<GetItemsReqOpts> = options => Api.send('/items', 'POST', options, true);
export const getAllItems: ApiRequest<any> = () => Api.send('/items', 'GET', {}, true);
export const getItem: ApiRequest<GetItemReqOpts> = options => Api.send('/items', 'POST', options, true);
export const updateItem: ApiRequest<UpdateItemReqOpts> = options => Api.send('/items/update', 'POST', options, true);
export const saveUserVote: ApiRequest<SaveVoteReqOpts> = options =>
	Api.send('/items/save-vote', 'POST', options, false);
export const getClientItem: ApiRequest<GetItemReqOpts> = options =>
	Api.send(`/items/${options.id}`, 'GET', options, false);
export const deleteItem: ApiRequest<DeleteItemReqOpts> = options => Api.send('/items/delete', 'POST', options, true);

export const getChannels: ApiRequest<GetChannelsReqOpts> = options => Api.send('/channels', 'POST', options, true);
export const getChannel: ApiRequest<GetChannelReqOpts> = options => Api.send('/channels', 'POST', options, true);
export const updateChannel: ApiRequest<UpdateChannelReqOpts> = options =>
	Api.send('/channels/update', 'POST', options, true);
export const deleteChannel: ApiRequest<DeleteChannelReqOpts> = options =>
	Api.send('/channels/delete', 'POST', options, true);

export const getSettings: ApiRequest<GetSettingsReqOpts> = options => Api.send('/settings', 'POST', options, true);
export const updateSettings: ApiRequest<UpdateSettingsReqOpts> = options =>
	Api.send('/settings/update', 'POST', options, true);

export const searchSeries: ApiRequest<SearchSeriesReqOpts> = options =>
	Api.send(`/imdb/tv-series?q=${options.search}`, 'GET', options, true);
export const getSeriesData: ApiRequest<GetSeriesDataReqOpts> = options =>
	Api.send(`/imdb/title/${options.id}`, 'GET', options, true);

export const createBackup: ApiRequest<CreateBackupReqOpts> = options =>
	Api.send('/backup/create', 'POST', options, true);
export const rollbackToBackup: ApiRequest<RollbackToBackupReqOpts> = options =>
	Api.send('/backup/rollback', 'POST', options, true);
export const getBackupItems: ApiRequest<GetBackupsReqOpts> = options => Api.send('/backup', 'POST', options, true);

export const autoSync: ApiRequest<AutoSyncReqOpts> = options => Api.send('/auto-sync/create', 'POST', options, true);
export const getAutoSyncItems: ApiRequest<GetAutoSyncItemsReqOpts> = options =>
	Api.send('/auto-sync', 'POST', options, true);
